import { createSlice } from '@reduxjs/toolkit';
import {
  getPorfolioCompany,
  deletePortfolioCompany,
} from '../thunk/portfolioComapniesThunk';
const initialState = {
  portfolioCompanyDetails: null,
  loading: false,
  updating: false,
  error: null,
};

const portfolioCompanySlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    clearPortfolioCompanyDetails: (state) => {
      state.portfolioCompanyDetails = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Contact Details
      .addCase(getPorfolioCompany.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPorfolioCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.portfolioCompanyDetails = action.payload.data;
      })
      .addCase(getPorfolioCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete Portfolio Company
      .addCase(deletePortfolioCompany.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePortfolioCompany.fulfilled, (state) => {
        state.loading = false;
        state.portfolioCompanyDetails = null; // Clear data on delete success
      })
      .addCase(deletePortfolioCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearPortfolioCompanyDetails } = portfolioCompanySlice.actions;
export default portfolioCompanySlice.reducer;
